const PageBannerSchema = (props) => ({
  title: 'AgSUS Banner de Página',
  fieldsets: [
    { id: 'default', title: 'Conteúdo', fields: ['eyebrow', 'title', 'lede'] },
    {
      id: 'style',
      title: 'Estilo',
      fields: ['variant', 'align', 'titleUppercase'],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Etiqueta',
      description: 'Categoria/seção em badge (ex.: Institucional).',
    },
    title: {
      title: 'Título',
      widget: 'textarea',
      description:
        'Título principal (h1). Use **palavra** para destacar parte em amarelo.',
    },
    lede: {
      title: 'Descrição (lede)',
      widget: 'textarea',
      description: 'Parágrafo introdutório.',
    },
    variant: {
      title: 'Cor de fundo',
      choices: [
        ['blue', 'Azul AgSUS (padrão)'],
        ['navy', 'Navy (mais escuro)'],
        ['yellow', 'Amarelo'],
        ['red', 'Vermelho'],
        ['white', 'Branco (texto escuro)'],
      ],
      default: 'blue',
    },
    align: {
      title: 'Alinhamento',
      choices: [
        ['left', 'Esquerda'],
        ['center', 'Centro'],
      ],
      default: 'left',
    },
    titleUppercase: {
      title: 'Título em MAIÚSCULAS',
      type: 'boolean',
      default: false,
    },
  },
  required: [],
});
export default PageBannerSchema;
